import React from 'react';
import { domesticLLMs, internationalLLMs } from '../mockData/llmPlatforms';

const allLLMs = [...domesticLLMs, ...internationalLLMs];

// Domain map for names that don't match exactly (variants / version strings)
const DOMAIN_OVERRIDES: Record<string, string> = {
  'gpt-4o':       'chatgpt.com',
  'gpt4':         'chatgpt.com',
  'chatgpt':      'chatgpt.com',
  'claude 3':     'claude.ai',
  'claude 3.5':   'claude.ai',
  'claude 3.7':   'claude.ai',
  'perplexity':   'www.perplexity.ai',
  'gemini':       'gemini.google.com',
  'kimi':         'kimi.moonshot.cn',
  'deepseek':     'chat.deepseek.com',
  '通义千问':      'tongyi.aliyun.com',
  '豆包':          'www.doubao.com',
  '文小言':        'yiyan.baidu.com',
  '元宝':          'yuanbao.tencent.com',
  '智谱清言':      'chatglm.cn',
  '天工':          'www.tiangong.cn',
  'abab':          'www.minimaxi.com',
  '百小应':        'www.baichuan-ai.com',
  'grok':          'grok.com',
  'meta ai':       'www.meta.ai',
  'copilot':       'copilot.microsoft.com',
  'le chat':       'chat.mistral.ai',
  'you.com':       'you.com',
  'pi':            'pi.ai',
  'poe':           'poe.com',
};

function getIconUrl(name: string): string {
  const key = name.toLowerCase().trim();
  if (DOMAIN_OVERRIDES[key]) {
    return `https://www.google.com/s2/favicons?domain=${DOMAIN_OVERRIDES[key]}&sz=64`;
  }
  const match = allLLMs.find(llm => llm.name.toLowerCase() === key || llm.id === key);
  if (match) return match.icon.replace('sz=128', 'sz=64');
  // Fallback: first word match
  const firstWord = key.split(/[\s-]/)[0];
  const partial = allLLMs.find(llm => llm.name.toLowerCase().startsWith(firstWord) || llm.id.startsWith(firstWord));
  if (partial) return partial.icon.replace('sz=128', 'sz=64');
  // Last resort: use first word as domain guess
  return `https://www.google.com/s2/favicons?domain=${firstWord}.com&sz=64`;
}

interface LLMIconProps {
  name: string;
  size?: number;
  showName?: boolean;
  className?: string;
}

/** Renders an AI platform favicon + optional name label. */
export const LLMIcon: React.FC<LLMIconProps> = ({ name, size = 16, showName = true, className = '' }) => {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <img
        src={getIconUrl(name)}
        alt={name}
        title={name}
        width={size}
        height={size}
        className="rounded-sm flex-shrink-0"
        style={{ width: size, height: size }}
      />
      {showName && <span>{name}</span>}
    </span>
  );
};
